import React, { useEffect, useState } from 'react';

import { Button, Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { useAppSelector } from 'hooks';
import { useAxios } from 'configs/requests';
import { Error, Loading } from 'components/Fetch';

import { QuestionnaireContent } from './Questionnaire';

interface IDeleteQuestionnaireModalProps {
  setShow: (show: boolean) => any;
  show: boolean;
  questionnaire: ICarePlanQuestionnaire;
  onDeleteQuestionnaire: any;
  carePlanTemplate?: ICarePlanTemplate;
}

const DeleteQuestionnaireModal = ({
  show,
  setShow,
  questionnaire,
  onDeleteQuestionnaire,
  carePlanTemplate
}: IDeleteQuestionnaireModalProps) => {
  const intl = useIntl();
  const patientUid = useAppSelector(({ patient }) => patient.data?.uid);
  const [error, setError] = useState<any>(false);

  const [{ loading, error: postError }, post] = useAxios(
    {
      url: carePlanTemplate
        ? '/clinician/2.0.0/CarePlanTemplate'
        : `/clinician/Patient/${patientUid}/CarePlan`,
      method: 'POST'
    },
    { manual: true }
  );

  const handleDelete = async () => {
    const questionnaireToDelete = {
      ...questionnaire,
      edit_status: 'deleted'
    };

    await post({
      data: {
        scheduled: [questionnaireToDelete],
        carePlanTemplate
      }
    });

    onDeleteQuestionnaire(questionnaire.id);
  };

  useEffect(() => {
    setError(postError);
  }, [postError, setError]);

  return (
    <Modal data-test="delete-questionnaire-modal" show={show} onHide={() => setShow(false)}>
      <Modal.Header className="align-items-center">
        <Modal.Title>
          {intl.formatMessage({ id: 'deleteKey' }) +
            ' ' +
            intl.formatMessage({ id: 'questionnaireKey' })}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body data-test="delete-questionnaire-modal-body">
        <QuestionnaireContent questionnaire={questionnaire} />
        {loading && <Loading className="mt-4" />}
        {error && (
          <Error
            retry={handleDelete}
            dismissible
            onClose={() => setError(false)}
            className="mt-4"
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          data-test="delete-questionnaire-modal-cancel-btn"
          variant="link"
          onClick={() => setShow(false)}
        >
          {intl.formatMessage({ id: 'Cancel' })}
        </Button>
        <Button
          data-test="delete-questionnaire-modal-delete-btn"
          variant="danger"
          onClick={handleDelete}
        >
          {intl.formatMessage({ id: 'deleteKey' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteQuestionnaireModal;
